import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=403a4784&scoped=true&"
import script from "./InfoBanner.vue?vue&type=script&lang=ts&"
export * from "./InfoBanner.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&id=403a4784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403a4784",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
